import React from 'react';
import { Section } from './Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function WhoIsItForSection() {
  const forWho = ['eres una mujer latina en USA con poco tiempo', 'te sientes inflamada con frecuencia', 'quieres algo práctico y fácil de seguir', 'buscas sentirte más ligera sin extremos'];
  const notForWho = ['buscas una promesa milagrosa', 'no quieres seguir indicaciones simples por 3 días', 'necesitas tratamiento médico personalizado', 'esperas perder muchas libras de la noche a la mañana'];
  return <Section className="bg-sage" data-id="element-159">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-160">
        <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-forest" data-id="element-161">
          <h3 className="font-serif text-2xl font-bold text-forest mb-6 flex items-center gap-2" data-id="element-162">
            <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-163" />
            Esta guía sí es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-164">
            {forWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-165">
                <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-166" />
                <span className="text-gray-700" data-id="element-167">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-red-500" data-id="element-168">
          <h3 className="font-serif text-2xl font-bold text-forest mb-6 flex items-center gap-2" data-id="element-169">
            <XCircle className="w-6 h-6 text-red-500" data-id="element-170" />
            Esta guía NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-171">
            {notForWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-172">
                <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-1" data-id="element-173" />
                <span className="text-gray-700" data-id="element-174">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}